import createLoader from './createLoader';
import loadScript from './loadScript';
var loadPlayer = createLoader(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$clientId = _ref.clientId,
      clientId = _ref$clientId === void 0 ? 'radiocanadaca_tele' : _ref$clientId,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '//services.radio-canada.ca/media/player/client/{clientId}' : _ref$url;

  return loadScript(url.replace(/\{\s*clientId\s*\}/gi, clientId));
}, function () {
  return typeof window.RadioCanada !== 'undefined' && typeof window.RadioCanada.player !== 'undefined' ? window.RadioCanada.player : null;
});
export default loadPlayer;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/services/es/loadSrcPlayer.js
// module id = null
// module chunks = 